import { CSSProperties } from 'react';
import type { ImageWithDimensions } from '../types';

export const calculateHorizontalJustifiedLayout = (
  images: ImageWithDimensions[],
  rowHeight: number,
  imageSpacing = 0
) => {
  const aspectRatios = images.map((image) => image.width / image.height);
  const scaledWidths = aspectRatios.map((ratio) => ratio * rowHeight);
  const spacingWidth = (images.length - 1) * imageSpacing;
  const totalWidth = scaledWidths.reduce((total, width) => total + width, 0) + spacingWidth;
  const percentageWidths = scaledWidths.map((width) => (width / totalWidth) * 100 + '%');
  const percentageSpacing = (imageSpacing / totalWidth) * 100;
  const maxTableWidth = totalWidth + 'px';

  return { percentageWidths, percentageSpacing, maxTableWidth };
};

export const getJustifiedLayoutPaddingStyle = (
  index: number,
  imageCount: number,
  imageSpacing = 0,
  unit = '%',
  isVertical = false
): CSSProperties => {
  const halvedSpacing = imageSpacing / 2 + unit;

  switch (index) {
    case 0:
      if (imageCount === 1) return {};
      return isVertical ? { paddingBottom: halvedSpacing } : { paddingRight: halvedSpacing };

    case imageCount - 1:
      return isVertical ? { paddingTop: halvedSpacing } : { paddingLeft: halvedSpacing };

    default:
      return isVertical
        ? { paddingTop: halvedSpacing, paddingBottom: halvedSpacing }
        : { paddingLeft: halvedSpacing, paddingRight: halvedSpacing };
  }
};
